<ng-container *ngIf="returnRequests$ | async as returnRequests">
  <div class="container">
    <!-- BODY -->
    <div class="cx-order-history-body">
      <ng-container *ngIf="returnRequests.pagination.totalResults > 0">
        <!-- Select Form and Pagination Top -->
        <div class="cx-order-history-sort top row">
          <label
            class="
              cx-order-history-form-group
              form-group
              col-sm-12 col-md-4 col-lg-4
            "
            ><span>{{ 'returnRequestList.sortBy' | cxTranslate }}</span>
            <cx-sorting
              [sortOptions]="returnRequests.sorts"
              [sortLabels]="getSortLabels() | async"
              (sortListEvent)="changeSortCode($event)"
              [selectedOption]="returnRequests.pagination.sort"
            ></cx-sorting>
          </label>
          <div class="cx-order-history-pagination">
            <cx-pagination
              [pagination]="returnRequests.pagination"
              (viewPageEvent)="pageChange($event)"
            ></cx-pagination>
          </div>
        </div>
        <!-- TABLE -->
        <table class="table cx-order-history-table">
          <thead class="cx-order-history-thead-mobile">
            <th scope="col">
              {{ 'returnRequestList.returnRequestId' | cxTranslate }}
            </th>
            <th scope="col">{{ 'returnRequestList.orderId' | cxTranslate }}</th>
            <th scope="col">
              {{ 'returnRequestList.date' | cxTranslate }}
            </th>
            <th scope="col">{{ 'returnRequestList.status' | cxTranslate }}</th>
          </thead>
          <tbody>
            <tr *ngFor="let return of returnRequests.returnRequests">
              <td class="cx-order-history-code">
                <div class="d-md-none cx-order-history-label">
                  {{ 'returnRequestList.returnRequestId' | cxTranslate }}
                </div>
                <a
                  [routerLink]="
                    {
                      cxRoute: 'returnRequestDetails',
                      params: return
                    } | cxUrl
                  "
                  class="cx-order-history-value"
                >
                  {{ return?.rma }}</a
                >
              </td>
              <td class="cx-order-history-code">
                <div class="d-md-none cx-order-history-label">
                  {{ 'returnRequestList.orderId' | cxTranslate }}
                </div>
                <a
                  [routerLink]="
                    {
                      cxRoute: 'orderDetails',
                      params: return?.order
                    } | cxUrl
                  "
                  class="cx-order-history-value"
                >
                  {{ return?.order?.code }}</a
                >
              </td>

              <td class="cx-order-history-placed">
                <div class="d-md-none cx-order-history-label">
                  {{ 'returnRequestList.date' | cxTranslate }}
                </div>
                {{ return?.creationTime | cxDate: 'longDate' }}
              </td>
              <td class="cx-order-history-status">
                <div class="d-md-none cx-order-history-label">
                  {{ 'returnRequestList.status' | cxTranslate }}
                </div>
                {{
                  'returnRequestList.statusDisplay_' + return?.status
                    | cxTranslate
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Select Form and Pagination Bottom -->
        <div class="cx-order-history-sort bottom row">
          <label
            class="
              cx-order-history-form-group
              form-group
              col-sm-12 col-md-4 col-lg-4
            "
            ><span>{{ 'returnRequestList.sortBy' | cxTranslate }}</span>
            <cx-sorting
              [sortOptions]="returnRequests.sorts"
              [sortLabels]="getSortLabels() | async"
              (sortListEvent)="changeSortCode($event)"
              [selectedOption]="returnRequests.pagination.sort"
            ></cx-sorting>
          </label>
          <div class="cx-order-history-pagination">
            <cx-pagination
              [pagination]="returnRequests.pagination"
              (viewPageEvent)="pageChange($event)"
            ></cx-pagination>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
